export default "__VITE_ASSET__872a6fe1__"